<div class="spinner-backdrop" *ngIf="spinner.isLoading | async">
    <div class="spinner"></div>
</div>
